/**
 * ترجمات المنتجات من قاعدتنا — تُحمَّل مرّة وتُشارَك عبر React Query cache.
 * تُستخدم مع localizedTitle/localizedDescription كطبقة أولى قبل metafields Shopify.
 */
import { useQuery } from "@tanstack/react-query";
import { useServerFn } from "@tanstack/react-start";
import { getProductTranslations } from "@/utils/productTranslations.functions";
import type { TranslationLookup } from "@/lib/shopify-localize";

export function useProductTranslations(): TranslationLookup {
  const fn = useServerFn(getProductTranslations);
  const { data } = useQuery({
    queryKey: ["product-translations"],
    queryFn: () => fn(),
    staleTime: 5 * 60_000,
  });
  return data?.map ?? null;
}
